"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookDataProviderItemType = 'FacebookDataProviderItem:#Exchange';
exports.FacebookProviderScopeType = 'FacebookProviderScope:#Exchange';
exports.FileAttachmentDataProviderItemType = 'FileAttachmentDataProviderItem:#Exchange';
exports.FolderAttachmentDataProviderItemType = 'FolderAttachmentDataProviderItem:#Exchange';
exports.GDriveDataProviderItemType = 'GDriveDataProviderItem:#Exchange';
exports.OneDriveProScopeName = 'OneDriveProScope:#Exchange';
exports.ScopeBreadcrumbId = 'scopeId';
exports.SearchBreadcrumbId = 'searchId';
exports.SizeLimitInKbToSuggestSharing = 5 * 1024;
//# sourceMappingURL=filePickerConstants.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/utils/filePickerConstants.js
// module id = 1755
// module chunks = 2 3 43 106 107